import { VehiclePreview } from '../components';
import { Vehicle } from '@sharedTypes/Vehicle';

interface NoLongerAvailableViewProps {
  vehicle: Vehicle;
}

const NoLongerAvailableView = ({
  vehicle,
}: NoLongerAvailableViewProps): JSX.Element => {
  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <section className="db-section">
        <p className="db-question">
          Sorry, this car has already been reserved.
        </p>
        <VehiclePreview {...vehicle} />
        <p className="ch-mt--2">
          We’re unable to complete your reservation online. Please contact your
          product consultant for more information.
        </p>
      </section>
    </div>
  );
};

export default NoLongerAvailableView;
